//user
import { useEffect, useState, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";

const UserForm = (props) => {
  const frmRef = useRef({});
  const [empData, setEmpData] = useState();
  const [regionData, setRegionData] = useState([]);
  const [regionId, setRegionId] = useState(0);
  const [areaData, setAreaData] = useState([]);
  const [areaId, setAreaId] = useState(0);
  const [showRegion, setShowRegion] = useState(false);
  const [showArea, setShowArea] = useState(false);
  const [selectedUseCase, setSelectedUseCase] = useState("");
  const [userCase, setUserCase] = useState("");
  const [licenses, setLicenses] = useState({});
  const [flag, setFlag] = useState(false);
  const [userName, setUserName] = useState("");
  const [IsMainUser, setIsMainUser] = useState(false);
  const { sendRequest: getLicenses } = useHttp();
  const { sendRequest: getAreaData } = useHttp();

  const FillDetail = () => {
    getAreaData(
      {
        url: `/api/areaDetails/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          
          setAreaData(res.data);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getAreaData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getUser } = useHttp();

  useEffect(() => {
    getUser(
      {
        url: `/api/employeeDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (myres) => {
        if (myres) {
          //changesdonebysneha
          var res=myres;
          const filterEmp =
            res && res.filter((item) => item.employeeType === "Employee");

          setEmpData(filterEmp);
        }
      }
    );
  }, [getUser]);

  const [backImage, setBackImage] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );
  const [profileUrl, setprofileUrl] = useState();

  const attachmentFolder = localStorage.getItem("attachmentFolder");
  const uploadProImage = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/user/${new Date().valueOf()}/${file.name}`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setBackImage(`${process.env.REACT_APP_FILE_URL}${data.url}`);
        setprofileUrl(data.url);
      })
      .catch((err) => {
        //console.error(err)
      });
  };

  const handleEmpChange = (e) => {
    const id = parseInt(e.target.value);
    if (id) {
      const data = empData && empData.filter((item) => item.empId === id);
      console.log(data);
      frmRef.current.employee_code.value = data && data[0].employeeCode;
      frmRef.current.department.value = data && data[0].departmentName;
      frmRef.current.designation.value = data && data[0].designationName;
      frmRef.current.user_case.value = (data && data[0].useCase) || "";
      frmRef.current.email_id.value = data && data[0].workEmailId;

      frmRef.current.employee_code.value = data && data[0].employeeCode;

      const usecase = (data && data[0].useCase) || "";

      updateLicenseDetails(usecase);

      setShowRegion(usecase === "Procurement" || usecase === "Sales");
      setShowArea(usecase === "Procurement");
      setAreaId((data && data[0].areaId) || 0);
      setRegionId((data && data[0].regionId) || 0);
      setUserName((data && data[0].userName) || "");
      setBackImage(
        `${process.env.REACT_APP_FILE_URL}${data && data[0].profileurl}`
      );
    }
  };

  useEffect(() => {
    getLicenses(
      {
        url: "/api/licenses/",
        method: "POST",
        body: { orgId: localStorage.getItem("orgId") },
      },
      (res) => {
        if (res) {
          //changesdonebysneha
          setLicenses(res|| []);
        }
      }
    );
  }, [getLicenses]);

  useEffect(() => {
    if (props.update) {
      setSelectedUseCase(props.update.useCase);
    }
  }, [props.update]);

  useEffect(() => {
    if (selectedUseCase && Object.keys(licenses).length > 0) {
      updateLicenseDetails(selectedUseCase);
    }
  }, [selectedUseCase, licenses]);

  const [selectedLicenseData, setSelectedLicenseData] = useState({
    total: null,
    active: null,
    balance: null,
  });

  const handleCaseChange = (e) => {
    const usecase = e.target.value;
    setSelectedUseCase(usecase);
    setUserCase(usecase);
    setShowRegion(usecase === "Procurement" || usecase === "Sales");
    setShowArea(usecase === "Procurement");

    let total = 0,
      active = 0,
      balance = 0;

    switch (usecase) {
      case "AdminPanel":
        total = licenses?.adminPanelLicence || 0;
        active = licenses?.activeAdminpanel || 0;
        balance = licenses?.balanceAdminpanel || 0;
        break;
      case "Sales":
        total = licenses?.salesLicence || 0;
        active = licenses?.activeSales || 0;
        balance = licenses?.balanceSales || 0;
        break;
      case "Warehouse":
        total = licenses?.warehouseLicence || 0;
        active = licenses?.activeWarehouse || 0;
        balance = licenses?.balanceWarehouse || 0;
        break;
      case "Procurement":
        total = licenses?.procurementLicence || 0;
        active = licenses?.activeProcurement || 0;
        balance = licenses?.balanceprocurement || 0;
        break;
      case "CommercialFarming":
        total = licenses?.commercialFarmingLicence || 0;
        active = licenses?.activeCommercialFarming || 0;
        balance = licenses?.balanceCommercialFarming || 0;
        break;
      case "Market Detail":
        total = licenses?.marketDetailLicence || 0;
        active = licenses?.activeMarketDetail || 0;
        balance = licenses?.balanceMarketDetail || 0;
        break;
      case "Agri Promoter":
        total = licenses?.agriPromoterLicence || 0;
        active = licenses?.activeAgriPromoter || 0;
        balance = licenses?.balanceagriPromoter || 0;
        break;
      case "Warehouse Procurement":
        total = licenses?.warehouseProcurementLicence || 0;
        active = licenses?.activeWarehouseProcurement || 0;
        balance = licenses?.balanceWarehouseProcurement || 0;
        break;

      case "Nursery":
        total = licenses?.nurseryLicence || 0;
        active = licenses?.activeNurseryLicence || 0;
        balance = licenses?.balanceNurseryLicence || 0;
        console.log("total", total);
        console.log("active", active);
        console.log("balance", balance);
        break;

      case "Research Program":
        total = licenses?.researchProgramLicence || 0;
        active = licenses?.activeresearchProgramLicence || 0;
        balance = licenses?.balanceResearchProgramLicence || 0;
        break;

      case "Seed Production":
        total = licenses?.seedProductionLicence || 0;
        active = licenses?.activeseedProductionLicence || 0;
        balance = licenses?.balanceseedProductionLicence || 0;
        break;

      default:
        total = 0;
        active = 0;
        balance = 0;
        break;
    }

    setSelectedLicenseData({ total, active, balance });

    if (balance > 0) {
      setFlag(true);
    } else {
      toast.error("License not available");
      setFlag(false);
    }
  };

  const { sendRequest: postAddUser } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    if (flag === true) {
      const data = {
        orgId: localStorage.getItem("orgId"),
        useCase: frmRef.current.user_case.value,
        empId: frmRef.current.employee_name.value,
        email: frmRef.current.email_id.value,
        userName: userName.trim(),
        status: frmRef.current.status.value === "true" ? 1 : 0,
        serviceId: props.sId,
        isMainUser: IsMainUser,
      };
      if (showRegion) {
        data.regionId = regionId;
      }

      if (showArea) {
        data.areaId = areaId;
      }
      if (props.update) {
        data["userId"] = props.update.userId;
      }
      console.log(data);
      postAddUser(
        {
          url: "/api/employee/",
          method: props.update ? "PUT" : "POST",
          // method:"POST",
          body: data,
        },
        (data) => {
          //console.log(data);
          toast.success(
            `User ${props.update ? "Updated" : "Added"} successfully`
          );
          props.addForm(false);
        },
        (error) => {
          //console.error("Error adding user:", error);
          toast.error("user already exists");
        }
      );
    } else {
      toast.error("License not available");
    }
  };

  useEffect(() => {
    console.log(props.update);
    if (props.update) {
      frmRef.current.user_case.value = props.update.useCase;

      frmRef.current.status.value = props.update.activeStatus;
      frmRef.current.employee_code.value = props.update.employeeCode;
      frmRef.current.email_id.value = props.update.workEmailId;
      setUserName(props.update.userName);
      frmRef.current.employee_name.value = props.update.empId;

      frmRef.current.department.value = props.update.departmentName;

      frmRef.current.designation.value = props.update.designationName;
      setprofileUrl(props.update.profileurl);
      setBackImage(
        `${process.env.REACT_APP_FILE_URL}${props.update.profileurl}`
      );
      frmRef.current.department.disabled = true;
      // frmRef.current.user_case.disabled = true;

      frmRef.current.employee_code.disabled = true;
      // frmRef.current.user_name.disabled = true;
      frmRef.current.employee_name.disabled = true;

      frmRef.current.department.disabled = true;

      frmRef.current.designation.disabled = true;
      setUserCase(props.update.useCase || "");
      setFlag(true);
      const usecase = (props.update && props.update.useCase) || "";
      setShowRegion(usecase === "Procurement" || usecase === "Sales");
      setShowArea(usecase === "Procurement");
      setAreaId((props.update && props.update.areaId) || 0);
      setRegionId((props.update && props.update.regionId) || 0);
      setIsMainUser(props.update.isMainUser);
    }
  }, [props.update]);

  useEffect(() => {
    updateLicenseDetails(userCase);
  }, [userCase]);

  const updateLicenseDetails = (userCase) => {
    let total = 0,
      active = 0,
      balance = 0;

    console.log("usecase", userCase);

    switch (userCase) {
      case "AdminPanel":
        total = licenses?.adminPanelLicence || 0;
        active = licenses?.activeAdminpanel || 0;
        balance = licenses?.balanceAdminpanel || 0;
        break;
      case "Sales":
        total = licenses?.salesLicence || 0;
        active = licenses?.activeSales || 0;
        balance = licenses?.balanceSales || 0;
        break;
      case "Warehouse":
        total = licenses?.warehouseLicence || 0;
        active = licenses?.activeWarehouse || 0;
        balance = licenses?.balanceWarehouse || 0;
        break;
      case "Procurement":
        total = licenses?.procurementLicence || 0;
        active = licenses?.activeProcurement || 0;
        balance = licenses?.balanceprocurement || 0;
        break;
      case "CommercialFarming":
        total = licenses?.commercialFarmingLicence || 0;
        active = licenses?.activeCommercialFarming || 0;
        balance = licenses?.balanceCommercialFarming || 0;
        break;
      case "Market Detail":
        total = licenses?.marketDetailLicence || 0;
        active = licenses?.activeMarketDetail || 0;
        balance = licenses?.balanceMarketDetail || 0;
        break;
      case "Agri Promoter":
        total = licenses?.agriPromoterLicence || 0;
        active = licenses?.activeAgriPromoter || 0;
        balance = licenses?.balanceagriPromoter || 0;
        break;
      case "Warehouse Procurement":
        total = licenses?.warehouseProcurementLicence || 0;
        active = licenses?.activeWarehouseProcurement || 0;
        balance = licenses?.balanceWarehouseProcurement || 0;
        break;

      case "Nursery":
        total = licenses?.nurseryLicence || 0;
        active = licenses?.activeNurseryLicence || 0;
        balance = licenses?.balanceNurseryLicence || 0;
        break;

      case "Research Program":
        total = licenses?.researchProgramLicence || 0;
        active = licenses?.activeresearchProgramLicence || 0;
        balance = licenses?.balanceResearchProgramLicence || 0;
        break;

      case "Seed Production":
        total = licenses?.seedProductionLicence || 0;
        active = licenses?.activeseedProductionLicence || 0;
        balance = licenses?.balanceseedProductionLicence || 0;
        break;

      default:
        total = 0;
        active = 0;
        balance = 0;
        break;
    }
    console.log("total, active, balance", total, active, balance);
    setSelectedLicenseData({ total, active, balance });
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            &nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">User Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 text-center">
                      <div className="form-group mt-5">
                        <img
                          src={`${backImage}`}
                          className="user-image img-circle"
                          width="160"
                          height="160"
                          alt="User Image"
                        />
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-6">
                          {" "}
                          <div className="form-group">
                            <label>Employee Name</label>
                            <select
                              className="form-control"
                              ref={(el) =>
                                (frmRef.current["employee_name"] = el)
                              }
                              onChange={handleEmpChange}
                              required
                            >
                              <option value="">Select</option>
                              {empData &&
                                empData.map((x) => (
                                  <option
                                    key={x.empId}
                                    value={x.empId}
                                    selected={
                                      props.update &&
                                      x.empId === props.update.empId
                                    }
                                  >
                                    {x.employeeName}
                                  </option>
                                ))}{" "}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          {" "}
                          <div className="form-group">
                            <label>User Case </label>
                            <select
                              className="form-control"
                              style={{ width: "100%" }}
                              ref={(el) => (frmRef.current["user_case"] = el)}
                              onChange={handleCaseChange}
                              required
                            >
                              <option value="">Select</option>
                              <option value="AdminPanel">AdminPanel</option>
                              <option value="Procurement">Procurement</option>
                              <option value="CommercialFarming">
                                Commercial Farming
                              </option>
                              <option value="Warehouse">Warehouse</option>
                              <option value="Sales">Sales</option>
                              <option value="Market Detail">
                                Market Detail
                              </option>
                              <option value="Agri Promoter">
                                Agri Promoter
                              </option>
                              <option value="Nursery">Nursery</option>
                              <option value="Warehouse Procurement">
                                Warehouse Procurement
                              </option>
                              <option value="Research Program">
                                Research Program
                              </option>
                              <option value="Seed Production">
                                Seed Production
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      {selectedLicenseData.total !== null && (
                        <div className="row alert alert">
                          <div className="col-md-4">
                            {" "}
                            <strong>Total Licenses:</strong>{" "}
                            {selectedLicenseData.total}
                          </div>
                          <div className="col-md-4">
                            {" "}
                            <strong>Active Licenses:</strong>{" "}
                            {selectedLicenseData.active}
                          </div>
                          <div className="col-md-4">
                            <strong>Balance Licenses:</strong>{" "}
                            {selectedLicenseData.balance}
                          </div>
                        </div>
                      )}

                      <div className="row">
                        <div className="col-md-6">
                          {" "}
                          <div className="form-group">
                            <label>Employee Code</label>
                            <input
                              ref={(el) =>
                                (frmRef.current["employee_code"] = el)
                              }
                              readOnly
                              type="text"
                              className="form-control"
                              style={{ width: "100%" }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          {" "}
                          <div className="form-group">
                            <label>User Name</label>
                            <input
                              type="text"
                              className="form-control"
                              style={{ width: "100%" }}
                              ref={(el) => (frmRef.current["user_name"] = el)}
                              value={userName}
                              onChange={(e) => {
                                setUserName(e.target.value);
                              }}
                              readOnly={props.update ? true : false}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          {" "}
                          <div className="form-group">
                            <label>Email Id</label>
                            <input
                              type="text"
                              className="form-control"
                              style={{ width: "100%" }}
                              ref={(el) => (frmRef.current["email_id"] = el)}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          {" "}
                          <div className="form-group">
                            <label>Department</label>
                            <input
                              type="text"
                              className="form-control"
                              style={{ width: "100%" }}
                              ref={(el) => (frmRef.current["department"] = el)}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Designation</label>
                            <input
                              type="text"
                              className="form-control"
                              style={{ width: "100%" }}
                              readOnly
                              ref={(el) => (frmRef.current["designation"] = el)}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          {" "}
                          <div className="form-group">
                            <label>Status</label>
                            <select
                              className="form-control"
                              style={{ width: "100%" }}
                              ref={(el) => (frmRef.current["status"] = el)}
                            >
                              <option value="">Select</option>
                              <option value="true">Active</option>
                              <option value="false">Deactive</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          {showArea && (
                            <div className="form-group">
                              <label>Area Name</label>
                              <select
                                className="form-control"
                                style={{ width: "100%" }}
                                value={areaId}
                                onChange={(e) => {
                                  setAreaId(e.target.value);
                                }}
                              >
                                <option value="0">Select</option>
                                {areaData &&
                                  areaData.map((x) => (
                                    <option key={x.areaId} value={x.areaId}>
                                      {x.areaName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          )}
                        </div>

                        <div className="col-md-6">
                          {showRegion && (
                            <div className="form-group">
                              <label>Region Name</label>
                              <select
                                className="form-control"
                                style={{ width: "100%" }}
                                value={regionId}
                                onChange={(e) => {
                                  setRegionId(e.target.value);
                                }}
                              >
                                <option value="0">Select</option>
                                {regionData &&
                                  regionData.map((x) => (
                                    <option key={x.regionId} value={x.regionId}>
                                      {x.regionName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-12 d-flex justify-content-center">
                      <div className="form-group form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="IsMainUser"
                          ref={(el) => (frmRef.current["IsMainUser"] = el)}
                          checked={IsMainUser}
                          onChange={(e) => setIsMainUser(e.target.checked)}
                        />
                        <label
                          className="form-check-label ml-2"
                          htmlFor="IsMainUser"
                          style={{ fontWeight: "500" }}
                        >
                          Is Master User
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-3">
                    <button type="submit" className="btn btn-primary px-5">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default UserForm;
